//i18n-setup.js
import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
Vue.use(VueI18n);

const loadedLanguages = []; // 我们的预装默认语言

let messages = {};
export const i18n = new VueI18n({
  locale: "en", // 设置语言环境
  fallbackLocale: "en",
  silentTranslationWarn: true,
  messages,
});

function setI18nLanguage(lang) {
  // console.log(lang);
  i18n.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}
//axios拉取的话数据在res.data中，import的话直接用res作为msg
export function loadLanguageAsync(lang) {
  const localData = () => import(`./locales/${lang}.js`);
  return localData().then((response) => {
    // console.log(response.default)
    if (!loadedLanguages.includes(lang)) {
      let msgs = response.default;
      loadedLanguages.push(lang);
      i18n.setLocaleMessage(lang, msgs);
      setI18nLanguage(lang);
    }
  });
}

export default i18n;
